import { createAction } from 'redux-actions';

import contentTypes from './types'

const actions = {
  setPurchasedSeries: createAction(contentTypes.SET_PURCHASED_SERIES),
  setPurchasedCommunity: createAction(contentTypes.SET_PURCHASED_COMMUNITY),
  addToPurchasedSeries: createAction(contentTypes.ADD_TO_PURCHASED_SERIES),
  addToPurchasedCommunity: createAction(contentTypes.ADD_TO_PURCHASED_COMMUNITY),
}

export default actions;